import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getCookieValue } from 'common/js/utils/cookie';
import { WindowWithProjectVars } from './types';
import { FINGERPRINT_ENDPOINT_PATH } from './constants';
import { logMessage } from './debug';

const SESSION_COOKIE_NAME = (window as WindowWithProjectVars).mtProjectVars?.session_cookie;

type SessionData = {
    sessionId?: string;
};

function getSessionId(): string | null {
    if (!SESSION_COOKIE_NAME) {
        logMessage('[fp] Session cookie name is not configured, skipping');
        return null;
    }

    const sessCookie = getCookieValue(SESSION_COOKIE_NAME);

    if (!sessCookie) {
        return null;
    }

    try {
        const sessData: SessionData = JSON.parse(decodeURIComponent(sessCookie));

        return sessData.sessionId ?? null;
    } catch (error) {
        logMessage('[fp] Failed to parse session cookie, invalid JSON', error);
        return null;
    }
}

export async function sendFingerprint(): Promise<void> {
    try {
        const sessionId = getSessionId();

        if (!sessionId) {
            logMessage('[fp] No session ID found, skipping fingerprint generation');
            return;
        }

        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const params = new URLSearchParams({
            fp: result.visitorId,
            confidence: result.confidence.score.toString(),
            sessionId,
        });

        await fetch(`${FINGERPRINT_ENDPOINT_PATH}/?${params.toString()}`, {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'include',
        });
    } catch (error) {
        logMessage('[fp] Error generating/sending fingerprint:', error);
    }
}

export function initFp(): void {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(sendFingerprint, { timeout: 5000 });
    } else {
        (window as Window).setTimeout(sendFingerprint, 2000);
    }
}
